const HELP_TEXTS = {
  header: {
    number:
      'This information can be found at people.zalando.net in the URL directly or in the expanded view of Show All on the same page.',
    roles:
      'If the selected role is Partner Consultancy Team, Sales Unit and Sales Team is mandatory to fill. Other roles such as Ops, Accounting, or Marketing do not require these fields to be filled.',
  },
};

export default HELP_TEXTS;
